<template>
  <v-chip
    small
    outlined
    :class="{ 'text-decoration-line-through grey--text': !link.exists }"
    :to="link.exists && target ? target : undefined"
    :close="closable"
    @click:close="$emit('remove', link)"
  >
    <v-icon left small>{{ icon }}</v-icon>
    {{ link.label }}
  </v-chip>
</template>

<script>
const ICONS = {
  'eval.brieffeedback': 'mdi-star-outline',
  'agent.project': 'mdi-clipboard-text-outline',
  'chat.conversation': 'mdi-chat-outline',
}

export default {
  name: 'LinkedObjectChip',
  props: {
    link: { type: Object, required: true },
    closable: { type: Boolean, default: false },
    /** Admin space: prefer the staff back-office route (e.g. agent session) when the API gives one. */
    admin: { type: Boolean, default: false },
  },
  computed: {
    target() {
      return (this.admin && this.link.admin_url) || this.link.url
    },
    icon() {
      return ICONS[this.link.type] || 'mdi-link-variant'
    },
  },
}
</script>
